import axios from 'axios';

const BASE_URL = process.env.REACT_APP_BASE_URL;

export function getSelectableAudioReferences(rateId) {
  return axios
    .get(`${BASE_URL}/audio/customPlaylists/selectableReferences`, {
      params: { rate: rateId },
    })
    .then(({ data }) => data);
}

export function createCustomPlaylist(name, chapters, rateId) {
  return axios
    .post(`${BASE_URL}/audio/customPlaylists`, {
      name,
      chapters,
      rate: rateId,
    })
    .then(({ data }) => data);
}

export function getCustomPlaylists() {
  return axios
    .get(`${BASE_URL}/audio/customPlaylists`)
    .then(({ data }) => data);
}

export function updateCustomPlaylist(playlistId, payload, rateId) {
  const body = { ...payload };

  if (rateId) {
    body.rate = rateId;
  }

  return axios
    .put(`${BASE_URL}/audio/customPlaylists/${playlistId}`, body)
    .then(({ data }) => data);
}

export function deleteCustomPlaylist(playlistId) {
  return axios
    .delete(`${BASE_URL}/audio/customPlaylists/${playlistId}`)
    .then(({ data }) => data);
}
